import TTS from "./index";
import { getATValue } from "@/modules/commonPopupResultHistory";
import { getBasePcode } from "@/modules/gamePcode";

function sequentialPlayer(self: any, _tc: TTS, _item: string) {
	// console.log("_tc:", _tc, "_item:", _item);
	_tc.soundFiles[_item].volume = self.state.soundVolume / 100;
	_tc.soundFiles[_item].play();
}

export default function playTTS(lobby: any, TTSClass: TTS, win: any) {
	const tc = TTSClass;
	const exclusion = [
		"m21", "m22", "m23", "m24",
		"m25", "m26", "m27", "m28",
		"m29", "m30", "m31", "m32",
		"m37", "m38", "m39"
	];

	const basePcode = getBasePcode(tc.pcode);
	
	//Todo: skip loading sounds if pcode contains exclusion
	if (exclusion.includes(basePcode))
		return;
	
	const _win = tc.pcode === "m16" ? (
		win.result === "Banker" ? win.angka1 :
		win.result === "Player" ? win.angka2 : win.angka //"Draw"
	) : null;
	
	const winary =
		["m7", "m10", "m11", "m19", "p12"].indexOf(tc.pcode) >= 0
		? win.split(",")
		: "m16" === tc.pcode
		? _win.split(",")
		: null;
	
	if (lobby.state.enableSound) {
		// console.log("playTTS Tp w", TTSClass.pcode, win);
		
		//Prototype only works for m20
		switch (TTSClass.pcode) {
			case "m14":
				if (win.angka3.length === 3)
					win.angka3 = "1 Pair";
				
				tc.soundFiles[win.angka3].volume = lobby.state.soundVolume / 100;
				tc.soundFiles[win.angka3].play();
			break;
			
			case "m11":
				//Double jackpot
				if ((win.match(/3/g) || []).length === 2) {
					tc.soundFiles["3,3"].volume = lobby.state.soundVolume / 100;
					tc.soundFiles["3,3"].play();
					
					const rest = winary.filter(item => item !== "3");
					
					window.setTimeout((self, _tc, _item) => {
						_tc.soundFiles[_item].volume = self.state.soundVolume / 100;
						_tc.soundFiles[_item].play();
					}, 1000, lobby, tc, rest);
				} else 
					winary.forEach(function(item, idx) {
						window.setTimeout(sequentialPlayer, idx * 1000, lobby, tc, item);
					});
			break;

			case "m16":
				if ((_win.match(/J|Q|K/g) || []).length === 3) {
					tc.soundFiles["3 Pictures"].volume = lobby.state.soundVolume / 100;
					tc.soundFiles["3 Pictures"].play();
				} else if ((_win.match(/K/g) || []).length === 2) {
					tc.soundFiles["K,K"].volume = lobby.state.soundVolume / 100;
					tc.soundFiles["K,K"].play();
					
					const rest = winary.filter(item => item !== "K");
					
					window.setTimeout((self, _tc, _item) => {
						_tc.soundFiles[_item].volume = self.state.soundVolume / 100;
						_tc.soundFiles[_item].play();
					}, 1000, lobby, tc, rest);
				} else
					winary.forEach(function(item, idx) {
						window.setTimeout(sequentialPlayer, idx * 1000, lobby, tc, item);
					});
					
				//Play TTS for Draw
				if (win.result === "Draw")
				 window.setTimeout(() => {
						//"A,T,8".split(",")
						const tieValue = winary
							.slice(0)
							.map(item => getATValue(item))
							.reduce((a, b) =>
								a + b
							) % 10;
						
						console.log("Draw timeout", tieValue);
						
						tc.soundFiles["tie_" + tieValue].volume = lobby.state.soundVolume / 100;
						tc.soundFiles["tie_" + tieValue].play();
					}, 4000);
			break;


			case "m7":
			case "m10":
			case "m19":
			case "p12":
				winary.forEach(function(item, idx) {
					window.setTimeout(sequentialPlayer, idx * 1000, lobby, tc, item);
				});
			break;
			
			//m20, p7, p6, p9, m13, m8, m6
			//monopoly, roulette, 24D, 12D, Billiards, Dice 6, 24D Spin
			default:
				//converts win to number
				const winnum = (TTSClass.pcode === "m13")
					? win
					: (TTSClass.pcode === "p9" && win === "20")
					? "jackpot"

					//Default wins
					: !isNaN(win)
					? Number(win)
					: win;
				
				console.log("default pcode", TTSClass.pcode, winnum);

				const soundFile = TTSClass.soundFiles[winnum];
			
				if (soundFile) {
					soundFile.volume = lobby.state.soundVolume / 100;
					soundFile.play();
				}
			break;
		}
	}
}
